const getNumericValue=(value)=> {
  if (typeof value==='number') return value;
  if (typeof value!=='string') return Number(value) || 0;
  return Number.parseFloat(value.replace(/[^0-9.-]/g,'')) || 0;
};

const getPricingUnit=(offering)=> {
  const value=String(
    offering?.pricing_unit ||
    offering?.price_unit ||
    offering?.unit_type ||
    'item'
  ).toLowerCase().trim();

  return ['batch','batches','pack','packs','dozen','dozens'].includes(value)
    ? 'batch'
    : 'item';
};

export const getItemsPerBatch=(offering)=> {
  const value=Number(
    offering?.items_per_batch ||
    offering?.batch_size ||
    offering?.quantity_per_batch ||
    1
  );

  return Number.isInteger(value) && value > 0 ? value : 1;
};

export const formatOfferingPrice=(offering)=> {
  const price=getNumericValue(offering?.base_price);
  return new Intl.NumberFormat('en-CA',{
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
};

export const getOfferingPriceLabel=(offering)=> {
  const formattedPrice=formatOfferingPrice(offering);
  const pricingUnit=getPricingUnit(offering);

  if (pricingUnit==='batch') {
    const itemCount=getItemsPerBatch(offering);
    return `${formattedPrice} per batch of ${itemCount}`;
  }

  return `${formattedPrice} per item`;
};